export enum AgendamentosTypes {
  'LOAD_REQUEST' = '@agendamentos/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@agendamentos/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@agendamentos/LOAD_FAILURE',

  'FILTER_AGEMDAMEMTOS' = '@entregaNoCd/FILTER_AGEMDAMEMTOS',
  'SORTER_AGEMDAMEMTOS' = '@entregaNoCd/SORTER_AGEMDAMEMTOS',
  'CLEAN_AGENDAMENTOS' = '@agendamentos/CLEAN_AGENDAMENTOS',
}

export interface IVeiculoDetalhes {
  placa: string;
  ano: number;
  ativo: boolean;
  tipoCarroceria: string;
}

export interface IMotoristaDetalhes {
  nome: string;
  cpf: string;
  mopp: boolean;
  habilitado: string;
  ativo: boolean;
  telefone: string;
}

export interface Pagination {
  total: number;
  pageSize: number;
  current: number;
  showSizeChanger: boolean;
  pageSizeOptions: string[];
}

export interface IAgendamentos {
  codVeiculo: number;
  placa: string;
  centroDistribuicao: string;
  cliente: string;
  codAgendamento: number;
  codCentroDistribuicao: number;
  codCliente: number;
  codTipoCarroceria: number;
  clienteRetira: boolean;
  codHorario: number;
  codMotorista: number;
  ordemCarga: number;
  codPlataforma: number;
  plataforma: string;
  codTransportadora: number;
  cpfMotorista: string;
  dhAgendamento: string;
  fimPrevisto: string;
  motorista: string;
  pesoBruto: number;
  status: string;
  transportadora: string;
  valor: number;
  tipoWms: string;
  detalheMotorista: IMotoristaDetalhes;
  detalheVeiculo: IVeiculoDetalhes;
  codCdd: number;
  codEmp: number;
  dhAguardando: Date | string;
  dhChegada: Date | string;
  dhEntrada: Date | string;
  dhSaida: Date | string;
  assoalho: string;
}

export interface IFitroAgendamentos {
  tipoWms: string;
  codAgendamento: number;
  codOrdemCarga: number;
  status: string;
  codParceiro: number;
  codTransportadora: number;
  placa: string;
  dataInicio: string | Date;
  dataFim: string | Date;
}

export interface IFilter {
  filter: object | undefined;
  codParceiro: number;
}

export interface AgendamentosState {
  readonly data: IAgendamentos[];

  readonly total: {
    total: number;
    qtdPlat: number;
    totalAge: number;
    totalExp: number;
  };

  readonly loading: boolean;
  readonly error: boolean;
  readonly filter?: IFilter;
  readonly pagination: Pagination;
  readonly sorter?: any;
}
